var map = {
	"./1/HELLO300_300.png": "./src/assets/texture/1/HELLO300_300.png",
	"./1/Ok300_300.png": "./src/assets/texture/1/Ok300_300.png",
	"./1/快看快看300x300.png": "./src/assets/texture/1/快看快看300x300.png",
	"./1/我保證300.png": "./src/assets/texture/1/我保證300.png",
	"./1/抱歉300.png": "./src/assets/texture/1/抱歉300.png",
	"./1/有問題嗎300x300.png": "./src/assets/texture/1/有問題嗎300x300.png",
	"./1/沒事啦300.png": "./src/assets/texture/1/沒事啦300.png",
	"./1/萬事拜託300x300.png": "./src/assets/texture/1/萬事拜託300x300.png",
	"./1/謝謝300.png": "./src/assets/texture/1/謝謝300.png",
	"./2/交件囉_300×300.png": "./src/assets/texture/2/交件囉_300×300.png",
	"./2/優惠大放送01_300×300.png": "./src/assets/texture/2/優惠大放送01_300×300.png",
	"./2/我查查_300×300.png": "./src/assets/texture/2/我查查_300×300.png",
	"./2/收到資料啦_300×300.png": "./src/assets/texture/2/收到資料啦_300×300.png",
	"./2/旅途愉快_300×300.png": "./src/assets/texture/2/旅途愉快_300×300.png",
	"./2/有問題隨時問_300×300.png": "./src/assets/texture/2/有問題隨時問_300×300.png",
	"./2/歡迎加入_300×300.png": "./src/assets/texture/2/歡迎加入_300×300.png",
	"./2/確認一下_300×300.png": "./src/assets/texture/2/確認一下_300×300.png",
	"./2/緊急通知_300×300.png": "./src/assets/texture/2/緊急通知_300×300.png",
	"./3/1108完稿改圖與字300x300.png": "./src/assets/texture/3/1108完稿改圖與字300x300.png",
	"./3/一起努力300x300.png": "./src/assets/texture/3/一起努力300x300.png",
	"./3/交資料囉300x300.png": "./src/assets/texture/3/交資料囉300x300.png",
	"./3/來登記300x300.png": "./src/assets/texture/3/來登記300x300.png",
	"./3/好耶300x300.png": "./src/assets/texture/3/好耶300x300.png",
	"./3/有好康300x300.png": "./src/assets/texture/3/有好康300x300.png",
	"./3/歡迎參與300x300.png": "./src/assets/texture/3/歡迎參與300x300.png",
	"./3/活動開始囉300x300.png": "./src/assets/texture/3/活動開始囉300x300.png",
	"./3/重要通知300x300.png": "./src/assets/texture/3/重要通知300x300.png",
	"./4/快來看看300.png": "./src/assets/texture/4/快來看看300.png",
	"./4/恭喜300.png": "./src/assets/texture/4/恭喜300.png",
	"./4/敬請期待300.png": "./src/assets/texture/4/敬請期待300.png",
	"./4/數量有限300.png": "./src/assets/texture/4/數量有限300.png",
	"./4/早鳥優惠300.png": "./src/assets/texture/4/早鳥優惠300.png",
	"./4/會員獨享300.png": "./src/assets/texture/4/會員獨享300.png",
	"./4/有獎徵答300.png": "./src/assets/texture/4/有獎徵答300.png",
	"./4/試用看看300.png": "./src/assets/texture/4/試用看看300.png",
	"./4/謝謝光臨300.png": "./src/assets/texture/4/謝謝光臨300.png",
	"./smile.png": "./src/assets/texture/smile.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/texture sync recursive \\.png$";